import type { SubscriptionOption } from '../types/subscription';

export type BillingInterval = 'monthly' | 'quarterly';

export const subscriptionOptions: Record<BillingInterval, SubscriptionOption[]> = {
  monthly: [
    {
      price: '$2',
      credits: '1,000',
      subscription: 'monthly2',
      benefits: [
        '1,000 monthly credits',
        'Up to 10 documents',
        'AI reviews of smaller documents',
        'Access to OpenAI (ChatGPT+)',
        'Character chats',
      ],
    },
    {
      price: '$9',
      credits: '6,000',
      subscription: 'monthly9',
      bestValue: true,
      benefits: [
        '6,000 monthly credits',
        'Up to 100 documents',
        'AI reviews of longer documents',
        'Access to OpenAI (ChatGPT+), Gemini, Nova, and Claude',
        'Enough credits for many Character chats',
        'Previous months credits rollover',
      ],
    },
    {
      price: '$15',
      credits: '14,000',
      subscription: 'monthly15',
      benefits: [
        '14,000 monthly credits',
        'Unlimited documents',
        'AI reviews of longer documents or book length manuscripts',
        'Access to OpenAI (ChatGPT+), Gemini, Nova, and Claude',
        'Excessive Character chatting!',
        'Previous months credits rollover',
      ],
    },
  ],
  quarterly: [
    {
      price: '$1.80',
      quarterlyPrice: '$5.40',
      credits: '1,000',
      subscription: 'monthly2quarter',
      benefits: [
        '1,000 monthly credits',
        'Up to 10 documents',
        'AI reviews of smaller documents',
        'Access to OpenAI (ChatGPT+)',
        'Character chats',
        '10% discount with quarterly billing',
      ],
    },
    {
      price: '$8.10',
      quarterlyPrice: '$24.30',
      credits: '6,000',
      subscription: 'monthly9quarter',
      bestValue: true,
      benefits: [
        '6,000 monthly credits',
        'Up to 100 documents',
        'AI reviews of longer documents',
        'Access to OpenAI (ChatGPT+), Gemini, Nova, and Claude',
        'Enough credits for many Character chats',
        'Previous months credits rollover',
        '10% discount with quarterly billing',
      ],
    },
    {
      price: '$12.50',
      quarterlyPrice: '$37.50',
      credits: '14,000',
      subscription: 'monthly15quarter',
      benefits: [
        '14,000 monthly credits',
        'Unlimited documents',
        'AI reviews of longer documents or book length manuscripts',
        'Access to OpenAI (ChatGPT+), Gemini, Nova, and Claude',
        'Excessive Character chatting!',
        'Previous months credits rollover',
        '10% discount with quarterly billing',
      ],
    },
  ],
};

export const oneOffSubscriptions: SubscriptionOption[] = [
  {
    price: '$5',
    credits: '3,000',
    subscription: 'pack5',
    benefits: [
      '3,000 credits',
      'Pay as you go',
      'Unlimited documents',
      'AI reviews of longer documents or book length manuscripts',
      'Access to OpenAI (ChatGPT+), Gemini, Nova, and Claude',
      'Excessive Character chatting!',
    ],
  },
  {
    price: '$10',
    credits: '8,000',
    subscription: 'pack10',
    benefits: [
      '8,000 credits',
      'Pay as you go',
      'Unlimited documents',
      'AI reviews of longer documents or book length manuscripts',
      'Access to OpenAI (ChatGPT+), Gemini, Nova, and Claude',
      'Excessive Character chatting!',
    ],
  },
  {
    price: '$20',
    credits: '18,000',
    subscription: 'pack20',
    benefits: [
      '18,000 credits',
      'Pay as you go',
      'Unlimited documents',
      'AI reviews of longer documents or book length manuscripts',
      'Access to OpenAI (ChatGPT+), Gemini, Nova, and Claude',
      'Excessive Character chatting!',
    ],
  },
];
